import { cloneDeep } from 'lodash';

/*
    TODO: удалить модель если она нигде не используется
*/
const sidebarModel = {
    state: {
        activeKeys: {},
    },
    reducers: {
        setActiveKeys(state, payload) {
            return { ...state, activeKeys: payload };
        },
    },
    effects: dispatch => ({
        setOnClickList(clickedKey, rootState) {
            const keys = cloneDeep(rootState.settingsSidebar.activeKeys);

            Object.keys(keys).forEach(key => {
                keys[key].isActive = key === clickedKey;
            });

            dispatch.settingsSidebar.setActiveKeys(keys);
        },
        onCheckAll(checked, rootState) {
            const keys = cloneDeep(rootState.settingsSidebar.activeKeys);

            Object.keys(keys).forEach(key => {
                keys[key].isActive = key === checked;
            });

            dispatch.settingsSidebar.setActiveKeys(keys);
        },
        setOnClickCheckbox(list, rootState) {
            const keys = cloneDeep(rootState.settingsSidebar.activeKeys);

            Object.keys(keys).forEach(key => {
                keys[key].isActive = list.includes(keys[key].title);
            });

            dispatch.settingsSidebar.setActiveKeys(keys);
        },
    }),
};

export default sidebarModel;
